import { createContext, useContext } from 'react'
import type { UserRole } from '../config/constants'
import type { StoredUser } from './authTokens'

export interface AuthContextValue {
  user: StoredUser | null
  role: UserRole | null
  isAuthenticated: boolean
  isLoading: boolean
  login: (email: string, password: string) => Promise<UserRole>
  logout: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider')
  return ctx
}
